<template>
  <el-button>
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  data() {
    name: "ButtonSecondary";
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.el-button {
  background-color: #ffffff;
  border-color: #ccc;
  color: #333;
  font-size: 14px;
  line-height: 20px;
  padding: 6px 12px;
  margin: 0px;
}

.el-button:hover {
  background-color: rgb(248, 246, 246);
  color: #333;
}
</style>
